module.exports = __webpack_public_path__ + "static/conoce-cocina-424f027221370684b9a0a69509ca42cc.jpg";